import { Select } from "antd";
import React from "react";

import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import { complianceFilterList } from "@/Constants/filterConstants";

/**
 * Renders a select component for filtering compliance status.
 *
 * @param {Object} value - the selected value
 * @param {Function} handleChange - callback function for handling value change
 * @return {JSX.Element} the select component for compliance status filtering
 */
const ComplianceStatusFilter = ({ value, handleChange }) => {
  return (
    <div className="ComplianceStatusFilter_Wrapper grid gap-3">
      <label
        className="label font-normal text-black"
        htmlFor="candidatePostcode"
      >
        Compliance Status
      </label>
      <Select
        showSearch
        style={{ width: "100%" }}
        placeholder="Select Status"
        optionFilterProp="children"
        className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
        suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
        onChange={(value) => {
          handleChange(value);
        }}
        allowClear={<RejectIcon cls="w-[20px] h-[20px] text-red" />}
        value={value}
      >
        {complianceFilterList.map((item, index) => {
          const { value, name, cls } = item;
          return (
            <Select.Option value={value} key={index} className={`${cls}`}>
              {name}
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};

export default ComplianceStatusFilter;
